module.exports = __webpack_public_path__ + "media/images/points_2-ad7071517af1eaa3d7606386261acd6a.svg";